<div class="modal-header border-b border-solid border-base-2 px-6 py-4">
    <h2 class="modal-title text-title-2 text-text-primary font-semibold" id="edit-tile-dialog-title">
        {{ dialogTitleKey() | translate }}
    </h2>
    <button
        type="button"
        class="btn btn-circle btn-ghost element-cancel"
        [attr.aria-label]="'accessibility.close-dialog' | translate"
        (click)="close()"
    ></button>
</div>
<div class="modal-body px-6 py-5">
    <div class="dialog-content">
        <si-form-item [label]="'tileDialog.labels.title' | translate">
            <input
                class="form-control"
                [ngModel]="currentTile().title"
                (ngModelChange)="updateTitle($event)"
                [attr.aria-label]="'tileDialog.labels.title' | translate"
                required
            />
        </si-form-item>
        <si-form-item [label]="'tileDialog.labels.tileType' | translate">
            <select
                class="form-select"
                [ngModel]="currentTile().canDownload"
                (ngModelChange)="updateCanDownload($event)"
                [attr.aria-label]="'tileDialog.labels.tileType' | translate"
                required
            >
                <option [ngValue]="false">Info</option>
                <option [ngValue]="true">Document</option>
            </select>
        </si-form-item>
        @if (currentTile().canDownload) {
            <si-form-item [label]="'tileDialog.labels.filePath' | translate">
                <input
                    class="form-control"
                    [ngModel]="currentTile().key"
                    (ngModelChange)="updateKey($event)"
                    [attr.aria-label]="'tileDialog.labels.filePath' | translate"
                    required
                />
            </si-form-item>
        }
        <si-form-item [label]="'tileDialog.labels.content' | translate">
            <textarea
                class="form-control"
                [ngModel]="currentTile().content"
                (ngModelChange)="updateContent($event)"
                [attr.aria-label]="'tileDialog.labels.content' | translate"
            ></textarea>
        </si-form-item>
    </div>
</div>
<div class="modal-footer border-t border-solid border-base-2 px-6 py-4">
    @if (isEditMode()) {
        <button
            class="btn btn-warning"
            type="button"
            [attr.aria-label]="'accessibility.delete-tile' | translate"
            [disabled]="isSubmitting()"
            (click)="deleteTile()"
        >
            <si-icon icon="element-delete" />
            <span>{{ 'tileDialog.buttons.delete' | translate }}</span>
        </button>
    }
    <button
        class="btn btn-primary"
        type="button"
        [attr.aria-label]="'accessibility.save-tile' | translate"
        (click)="save()"
        [disabled]="isSaveDisabled()"
    >
        {{ 'tileDialog.buttons.save' | translate }}
    </button>
</div>
